export let OpsVisibilityKeys = /*#__PURE__*/function (OpsVisibilityKeys) {
  OpsVisibilityKeys["OpsTasksVisibility"] = "ops-tasks-visibility";
  OpsVisibilityKeys["OpsAdminTasksVisibility"] = "ops-admin-tasks-visibility";
  return OpsVisibilityKeys;
}({});
export let SdVisibilityKeys = /*#__PURE__*/function (SdVisibilityKeys) {
  SdVisibilityKeys["SdStandardTasksVisibility"] = "servicedesk-standard-tasks-visibility";
  SdVisibilityKeys["SdAdvancedTasksVisibility"] = "servicedesk-advanced-tasks-visibility";
  return SdVisibilityKeys;
}({});
export let OgVisibilityKeys = /*#__PURE__*/function (OgVisibilityKeys) {
  OgVisibilityKeys["OgSetupProfileForNotificationsTaskVisibility"] = "opsgenie-user-profile-notifications-setup-task-visibility";
  OgVisibilityKeys["OgSetupTeamTaskVisibility"] = "opsgenie-response-team-setup-task-visibility";
  OgVisibilityKeys["OgAssignOwnerTeamToServicesTaskVisibility"] = "opsgenie-owner-team-assigned-to-service-task-visibility";
  OgVisibilityKeys["OgLevelUpIncidentManagementTaskVisibility"] = "opsgenie-incident-management-documentation-accessed-task-visibility";
  return OgVisibilityKeys;
}({});
export let VisibilityValues = /*#__PURE__*/function (VisibilityValues) {
  VisibilityValues["Hidden"] = "hidden";
  VisibilityValues["Visible"] = "visible";
  VisibilityValues["Unset"] = "unset";
  return VisibilityValues;
}({});
export let SdVisibilityRoles = /*#__PURE__*/function (SdVisibilityRoles) {
  SdVisibilityRoles["Advanced"] = "advanced";
  SdVisibilityRoles["Standard"] = "standard";
  return SdVisibilityRoles;
}({});